import {
  CREATE_CUSTOMER_ADDRESS,
  FETCH_CUSTOMER_ADDRESSES,
  UPDATE_CUSTOMER_ADDRESS,
  DELETE_CUSTOMER_ADDRESS,
  ADD_GUEST_ADDRESS
} from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_CUSTOMER_ADDRESSES:
      return action.payload || state
    case CREATE_CUSTOMER_ADDRESS:
      return action.payload || state
    case UPDATE_CUSTOMER_ADDRESS:
      return action.payload || state
    case DELETE_CUSTOMER_ADDRESS:
      return action.payload || state
    case ADD_GUEST_ADDRESS:
      return [...state, action.payload]
    default:
      return state
  }
}
